import { useReduxState } from "../../explorer/redux/hooks";
import { defaultContext } from "../../site/configuration/defaultSettings";
import { reduxStoreConfig } from "../../site/configuration/reduxStoreConfig";
import { Language, NavigationState } from "../types";
import { AppInfo } from "../types/System/AppInfo";
import useAppContext from "./useAppContext";

const useLanguages: () => {
  currentLanguage: string;
  languages: Language[];
} = () => {
  const [navigationState] = useReduxState<NavigationState>(
    reduxStoreConfig.systemNavigationState
  );
  const [appInfo] = useReduxState<AppInfo>(reduxStoreConfig.systemAppInfo);
  const currentAppContext = useAppContext().currentContext;
  const languages =
    appInfo && appInfo.appContexts
      ? appInfo.appContexts.find(
          (c) => c.code.toLowerCase() === currentAppContext
        )?.languages 
        ??
        appInfo.appContexts.find((c) => c.code.toLowerCase() === defaultContext)
          ?.languages
      : [];
  const currentLanguage = navigationState.lang;
  return {
    currentLanguage,
    languages: languages ?? [],
  };
};
export default useLanguages;
